import { Box, Flex, Heading, Icon, Paragraph, Text } from '@zillow/constellation-10';
import { IconCheckmarkCircleOutline } from '@zillow/constellation-icons';

const IsItSecure = () => {
  const renderRow = ({ text }) => (
    <Flex css={{ display: 'flex', alignItems: 'center', marginBottom: 'xs' }}>
      <Icon
        css={{ color: 'icon.feedback.success.strong', marginRight: 'xs' }}
        size="md"
        render={<IconCheckmarkCircleOutline />}
      />
      <Text>{text}</Text>
    </Flex>
  );

  return (
    <Box css={{ textAlign: 'center', padding: '60px 16px' }}>
      <Heading textStyle="heading-sm" level={2} css={{ textAlign: 'center', marginBottom: 'default' }}>
        Is it secure to pay my rent online?
      </Heading>

      <Box css={{ maxWidth: '700px', margin: 'auto' }}>
        <Paragraph css={{ marginBottom: 'loose' }}>
          You definitely want your payments to stay private, and so do we. That’s why we partner with Stripe and Plaid
          for processing. They’re experts on payment security, and together we make it safe to pay your rent from
          anywhere there’s internet.
        </Paragraph>
        {renderRow({
          text: 'Bank-grade security and encryption',
        })}
        {renderRow({
          text: `Zillow never stores your bank login or card info`,
        })}
        {renderRow({
          text: 'Your landlord never sees your bank details or card numbers',
        })}
      </Box>
    </Box>
  );
};

export default IsItSecure;
